import { render, staticRenderFns } from "./VendorNotificationsProvider.vue?vue&type=template&id=6b28dd0c&scoped=true"
import script from "./VendorNotificationsProvider.vue?vue&type=script&lang=ts"
export * from "./VendorNotificationsProvider.vue?vue&type=script&lang=ts"
import style0 from "./VendorNotificationsProvider.vue?vue&type=style&index=0&id=6b28dd0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b28dd0c",
  null
  
)

export default component.exports